import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent;
  try {
    // Priority: 1. Direct component passed (icon prop) 2. Name string lookup (name prop)
    IconComponent = icon || (name && FiIcons[`Fi${name}`]);
  } catch (e) {
    console.warn("Icon load failed:", e);
    IconComponent = null;
  }
  
  return IconComponent ? React.createElement(IconComponent, props) : <FiAlertTriangle {...props} />;
};

export default SafeIcon;